import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Product } from '../types/product';
import { useCart } from '../context/CartContext';
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  const {
    addToCart
  } = useCart();
  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product);
  };
  return <div className="bg-white rounded-lg overflow-hidden group border border-gray-100 hover:shadow-lg transition-shadow duration-300" data-id="element-218">
      {/* Image Container */}
      <Link to={`/producto/${product.id}`} className="block relative" data-id="element-219">
        <div className="aspect-square bg-gray-50 p-4 flex items-center justify-center overflow-hidden" data-id="element-220">
          <img src={product.imageUrl} alt={product.title} className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform duration-300" data-id="element-221" />
        </div>

        {/* Badges */}
        {product.isHot && <span className="absolute top-2 left-2 bg-[#e53935] text-white text-xs font-bold px-2 py-1 rounded" data-id="element-222">
            Oferta
          </span>}
        {!product.inStock && <span className="absolute top-2 right-2 bg-gray-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-223">
            Agotado
          </span>}
      </Link>

      {/* Content */}
      <div className="p-4" data-id="element-224">
        {/* Brand */}
        <span className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-225">
          {product.brand}
        </span>

        {/* Title */}
        <Link to={`/producto/${product.id}`} data-id="element-226">
          <h3 className="text-sm text-gray-800 mt-1 mb-3 line-clamp-2 hover:text-[#0056b3] transition-colors min-h-[40px]" data-id="element-227">
            {product.title}
          </h3>
        </Link>

        {/* Price */}
        <div className="mb-3" data-id="element-228">
          <span className="text-xl font-bold text-gray-900" data-id="element-229">
            $ {product.price.toFixed(2)}
          </span>
        </div>

        {/* Stock Status */}
        <div className="mb-3" data-id="element-230">
          {product.inStock ? <span className="text-xs text-green-600" data-id="element-231">✓ Disponible</span> : <span className="text-xs text-gray-400" data-id="element-232">Agotado en línea</span>}
        </div>

        {/* Add to Cart Button */}
        <button onClick={handleAddToCart} disabled={!product.inStock} className={`w-full py-2.5 rounded text-sm font-medium flex items-center justify-center gap-2 transition-colors ${product.inStock ? 'bg-[#0056b3] text-white hover:bg-[#004494]' : 'bg-gray-100 text-gray-400 cursor-not-allowed'}`} data-id="element-233">
          <ShoppingCart className="w-4 h-4" data-id="element-234" />
          Agregar
        </button>
      </div>
    </div>;
}